// extracted by mini-css-extract-plugin
export var o_destacado_foto = "destacadoFoto-module--o_destacado_foto--e0f1c";
export var o_destacado_foto__btn = "destacadoFoto-module--o_destacado_foto__btn--77051";
export var o_destacado_foto__container = "destacadoFoto-module--o_destacado_foto__container--4f8a6";
export var o_destacado_foto__left = "destacadoFoto-module--o_destacado_foto__left--b78c5";
export var o_destacado_foto__right = "destacadoFoto-module--o_destacado_foto__right--2dbd0";